import { SortOrder } from "../sort-order";

export class TriggerRuleFilters {
  name: string;
  active: boolean;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
